import { useEditor, EditorContent } from '@tiptap/react'
import StarterKit from '@tiptap/starter-kit'

import { Color } from '@tiptap/extension-color'
import ListItem from '@tiptap/extension-list-item'
import TextStyle from '@tiptap/extension-text-style'
import Link from '@tiptap/extension-link'
import TextAlign from '@tiptap/extension-text-align'
import Underline from '@tiptap/extension-underline'
import { Placeholder } from '@tiptap/extension-placeholder'
import TipTapEditorBar from './TipTapEditorBar'
import './tiptap.scss'
import CustomImage from './extensions/CustomImage/CustomImage'
import clsx from 'clsx'
import { Youtube } from '@tiptap/extension-youtube'
import CustomYoutube from './extensions/CustomYoutube/CustomYoutube'
import { useEffect } from 'react'

const TiptapEditor = ({ values, onChange, theme, isPreview }) => {
  const containerStyle = {
    justifyContent: values?.verticalAlign || 'flex-start',
  }
  const editor = useEditor({
    extensions: [
      Link.configure({
        openOnClick: false,
      }),
      TextAlign.configure({
        types: ['heading', 'paragraph', 'customImage', 'youtube'],
      }),
      Placeholder.configure({
        emptyEditorClass: 'is-editor-empty',
        placeholder: 'Tell clients about yourself...',
      }),
      Underline.configure({}),
      CustomImage.configure({}),
      Color.configure({ types: [TextStyle.name, ListItem.name] }),
      TextStyle.configure({ types: [ListItem.name] }),
      StarterKit.configure({
        bulletList: {
          keepMarks: true,
          keepAttributes: false,
        },
        orderedList: {
          keepMarks: true,
          keepAttributes: false,
        },
      }),
      CustomYoutube.configure({}),
    ],
    onUpdate: ({ editor }) => {
      onChange(editor.getHTML())
    },
    editable: !isPreview,
    content: values?.content,
    placeholder: 'Enter your pitch here',
  })

  useEffect(() => {
    if (editor) {
      editor.setEditable(!isPreview)
    }
  }, [isPreview])

  return (
    <div className={clsx('tiptap-editor', theme)}>
      {!isPreview && <TipTapEditorBar editor={editor} theme={theme} />}
      <div
        className={clsx('flex flex-col flex-fill', { 'read-only': isPreview })}
        style={containerStyle}
      >
        <EditorContent editor={editor} />
      </div>
    </div>
  )
}

export default TiptapEditor
